import { useEffect, useRef } from 'react';
import api from '../helpers/api';

const REFRESH_COOLDOWN_MS = 30_000; // 30 seconds between refreshes

const usePermissionRefresh = () => {
  const lastRefresh = useRef(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;

      const now = Date.now();
      if (now - lastRefresh.current < REFRESH_COOLDOWN_MS) return;

      const authUserData = localStorage.getItem('authUser');
      if (!authUserData) return;

      lastRefresh.current = now;

      api
        .get('user/profile')
        .then((response) => {
          const profileData = response.data?.response;
          if (!profileData) return;

          const stored = localStorage.getItem('authUser');
          if (!stored) return;

          const authUser = JSON.parse(stored);
          const nextRestricted = Boolean(profileData.visibilityRestricted);
          const nextScope = profileData.assetTypeScope ?? null;
          const scopeChanged = Boolean(authUser.visibilityRestricted) !== nextRestricted
            || JSON.stringify(authUser.assetTypeScope ?? null) !== JSON.stringify(nextScope);

          const updated = {
            ...authUser,
            roles: profileData.roles ?? authUser.roles,
            permissions: profileData.permissions ?? authUser.permissions,
            role: profileData.role ?? authUser.role,
            visibilityRestricted: nextRestricted,
            assetTypeScope: nextScope,
          };

          localStorage.setItem('authUser', JSON.stringify(updated));
          window.dispatchEvent(new Event('permissions-updated'));
          if (scopeChanged) {
            // An admin changed this user's team scope mid-session: mounted lists are now stale.
            window.dispatchEvent(new Event('visibility-scope-changed'));
          }
        })
        .catch(() => {
          // Silently ignore — user will get fresh data on next login
        });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default usePermissionRefresh;
